module.exports = __webpack_public_path__ + "img/wall2.73ee0d44.jpg";